import { combineReducers, applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import registerNetworkReducer from './registerNetwork/reducer/registerNetworkReducer';
import applicationReducer from './application/reducer/applicationReducer';
import adminsReducer from './admins/reducer/reducer';
import clubs from './clubs/reducer';
import layouts from './layout/reducer';
import details from './details/reducer';
import cm from 'modules/cm/store';
import auth from 'auth/store/reducer';
import registration from '../screens/BrokerPortal/screens/Registration/store/reducer';
import * as firm from '../screens/Panel/screens/Firm/store';
import * as club from '../screens/Panel/screens/Club/store';
import * as network from '../screens/Panel/screens/Network/store';

const reducers = {
  registerNetworkReducer,
  applicationReducer,
  adminsReducer,
  clubs,
  layouts,
  details,
  ...cm,
  auth,
  registration,
  firmShow: firm.showReducer,
  clubShow: club.showReducer,
  networkShow: network.showReducer,
};

export type RootState = ReturnType<typeof store.getState>;

const store = createStore(
  combineReducers({
    ...reducers,
  }),
  composeWithDevTools(applyMiddleware(thunk)),
);

export default store;
